import {findIndex, isNull} from "lodash";
/**
 *
 * @param referencedArray
 * @param data
 * @param channelCallbacks
 * @returns {Array}
 */
export function create(referencedArray = [], data = {}, channelCallbacks) {
	data.map(_object => {

		let index = findIndex(referencedArray, {uri: _object.uri});

		if (channelCallbacks && channelCallbacks.update && _object) {
			_object.update = channelCallbacks.update;
			_object.update({});
		}

		if (index === -1) {
			referencedArray.push(_object);
		} else {
			referencedArray[index] = _object;
		}

	});
	return referencedArray;
}

/**
 *
 * @param reference
 * @param data
 */
export function update(reference = {}, data = {}) {

	try {
		Object.keys(reference).map(key => {

			if (typeof reference[key] != typeof data[key]) {
				return;
			}

			if (typeof reference[key] === "object" && !isNull(reference[key])) {
				update(reference[key], data[key]);
			} else {
				reference[key] = data[key];
			}

		});
	} catch (e) {
		return;
	}

}

/**
 *
 * @param referencedArray
 * @param key
 * @param value
 */
export function destroy(referencedArray = [], key = String, value = String) {

	referencedArray.filter((reference, iterator) => {
		if (reference[key] === value) {
			referencedArray.splice(iterator, 1);
		}
	});

}


export const reference = {
	create: create,
	update: update,
	destroy: destroy
};


// WEBPACK FOOTER //
// ./rapid/reference.helper.js